import React, { useCallback, useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, ScrollView, TextInput, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { social_searchArticleFeeds } from '../../store/actionsv1/social';
import { ArticleFeedProps } from '../../store/types/soc_svc';
import ArticleCard from './components/ArticleCard';
import ArticleFeedCard from './components/ArticleFeedCard';


const ArticleFeedsScreen = ({route, navigation}:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ search_value, setSearchValue ] = useState('') 

    const dispatch = useDispatch();
    const article_feeds:ArticleFeedProps[] = useSelector((state:any) => state.social.stored_article_feeds, (left, right) => left.lenght == right.length)

    useEffect(() => {
        getArticleFeedsFromServer(0)
    },[])

    const getArticleFeedsFromServer = async(offset:number) => {
        setLoading(true)
        await dispatch(social_searchArticleFeeds(search_value, offset))
        setLoading(false)
    }

    const handleSearch = async() => {
        getArticleFeedsFromServer(0)
    }

    const renderArticleFeeds = (data: { item:ArticleFeedProps, index:number }) => {
        return (
            <View style={{ margin:10 }}>
                <ArticleFeedCard article_feed={data.item} onArticleFeedPress={(af) => navigation.push('Articles', { article_feed_id: af.article_feed_id })} width={200}/>
            </View>
        )
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.shade100 }}>
            <ScrollView style={{ flex:1 }}>
                <View style={{ flexDirection:'row', alignItems:'center', padding:10, paddingRight:20, paddingLeft:20 }}>
                        <View style={{ flexDirection:'row', flex:1, backgroundColor:Colors.shades.white, borderRadius:22 }}>
                            <Icon containerStyle={{ alignSelf:'center', padding:10 }} name='search' type='feather' color={Colors.brand.electric} size={18} />
                            <TextInput style={{ flex:1, fontFamily:'barlow-regular', fontSize:14, color:Colors.brand.midnight, padding:5}} 
                            value={search_value} 
                            placeholder='Search Feeds...'
                            onChangeText={(text) => setSearchValue(text)}/>
                        </View>
                        <TouchableOpacity style={{ padding:5, marginLeft:10 }} onPress={() => handleSearch()}>
                            <Text size={14} color={Colors.brand.electric} weight='semibold'>Search</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={{ alignItems:'center' }}>
                        {loading ?
                        <View style={{ padding:20 }}>
                            <ActivityIndicator size='large' color={Colors.brand.midnight} />
                        </View>
                        :
                        <FlatList data={article_feeds} numColumns={2} renderItem={renderArticleFeeds} keyExtractor={(item) => item.article_feed_id.toString()}/>
                        }
                    </View>

            </ScrollView>
        </View>
    )
}


export default ArticleFeedsScreen